import axios from "axios";
import React from "react";
import { AnswerFileResult } from "../../../../store/viewmodels/AnswerFileViewModel";
import { AnswerSetResult } from "../../../../store/viewmodels/AnswerSetViewModel";
import { AnswerResult } from "../../../../store/viewmodels/AnswerViewModel";
import { Student } from "../../../../store/viewmodels/StudentViewModel";
import { getFileElement } from "../../../../utils/TaskContentServices";

interface VideoRecordingResultItemProps {
    answerSet: AnswerSetResult,
    answer: AnswerResult,
    student: Student
}

function VideoRecordingResultItem(props: VideoRecordingResultItemProps): JSX.Element {

    const downloadFile = (id: number, filename: string) => {
        const URL: string = window.location.href.includes('localhost') ? 'http://localhost:8000/api/answerfiles/' + id + '/get_video/' : '/api/answerfiles/' + id + '/get_video/'
        axios({
            url: URL,
            method: 'GET',
            responseType: 'blob',
        }).then((response) => {
            const blob = new Blob([response.data]);
            const videoURL = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = videoURL;
            link.setAttribute('download', filename + '.mp4');
            document.body.appendChild(link);
            link.click();
        });
    }

    const allFiles = props.student.answer_files ? props.student.answer_files : [];
    let downLoad: JSX.Element = <div className="text-red-500">Ei tiedostoa</div>;
    let watchVideo: JSX.Element = <div className="text-red-500">Ei tiedostoa</div>;

    const [closeButton, setCloseButton] = React.useState(<></>);
    const [show, setShow] = React.useState(<></>);

    function closeVideo() {
        setShow(<></>);
        setCloseButton(<></>);
    }

    function showVideo(file: AnswerFileResult | undefined) {
        if (!file) return;

        let videoElement = getFileElement(file);
        setShow(videoElement);

        let close = (
            <button className="block" type="button" onClick={() => closeVideo()} >
                <span className="ri-close-fill text-4xl text-teal-500 hover:text-teal-400"></span>
            </button>
        );
        setCloseButton(close);
    }

    for (let f: number = 0; f < allFiles.length; f++) {
        let file: AnswerFileResult | undefined = undefined;
        let answerFileItemsetId = allFiles[f].itemset;
        let answerFileItemId = allFiles[f].item?.id;
        let answerItemId = props.answer.item?.id;

        if (answerFileItemsetId && answerFileItemId && (answerItemId === answerFileItemId)) {
            let startTime = new Date(Date.parse(props.answerSet.start_time));
            let endTime = new Date(Date.parse(props.answerSet.end_time));
            let submitTime = new Date(allFiles[f].submit_time);
            if (startTime <= submitTime && submitTime <= endTime) {
                file = allFiles[f];
            }
        } else {
            file = searchItemSetByFileName(allFiles[f], props.answer, props.answerSet, props.student);
        }

    
        if (file) {
            let fileSplitted = file.file.split('/');
            let newFileName = decodeURI(fileSplitted[fileSplitted.length - 1]);

            downLoad = (
                <button className="block" type="button" onClick={() => downloadFile(file?.id!, newFileName)}>
                    <span className="ri-file-download-line text-4xl text-teal-500 hover:text-teal-400"></span>
                </button>);

            watchVideo = (
                <button className="" type="button" onClick={() => showVideo(file)}>
                    <span className="ri-movie-line text-4xl text-teal-500 hover:text-teal-400"></span>
                </button>
            );
            break;
        }
    }

    return (
        <div className="grid grid-cols-3">
            <div className="my-auto" key={"answeritem-" + props.answer.id}>{props.answer.item.name}</div>
            <div className="text-center m-auto justify-center" key={"download-" + props.answer.id}>{downLoad}</div>
            <div>
                <div className="text-center m-auto justify-center flex" key={"watchVideo-" + props.answer.id}>
                    {watchVideo}
                    {closeButton}
                </div>
                {show}
            </div>
        </div>);
}

function searchItemSetByFileName(answerFile: AnswerFileResult, answer: AnswerResult, answerSet: AnswerSetResult, student: Student): AnswerFileResult | undefined {
    let file = undefined;

    let startTime = new Date(Date.parse(answerSet.start_time));
    let endTime = new Date(Date.parse(answerSet.end_time));

    let fileSplitted = answerFile.file.split('/');
    let fileName = fileSplitted[fileSplitted.length - 1];

    fileName = fileName.replaceAll(student.username, '')
    fileName = fileName.replace(".mp4", '')

    let answer_item_name = answer.item?.name.replaceAll(' ', '_');
    let answer_itemset_name = answerSet.itemset.name.replaceAll(' ', '_');
    let fullAnswerName = answer_itemset_name + "_" + answer_item_name;

    fileName = decodeURI(fileName);
    fullAnswerName = decodeURI(fullAnswerName);

    if (fileName.includes(fullAnswerName)) {

        let timeInfo = fileName.replace(fullAnswerName, '');
        let timeSplitted = timeInfo.split('_');

        for (let i: number = 0; i < timeSplitted.length; i++) {
            if (timeSplitted[i] === "") {
                timeSplitted.splice(i, 1);
                i--;
            }
        }

        let day = 0;
        let month = 0;
        let year = 0;
        let hours = 0;
        let minutes = 0;

        if (timeSplitted.length === 5) {
            const d = timeSplitted[0];
            day = d ? parseInt(d) : 0;

            const m = timeSplitted[1];
            month = m ? parseInt(m) : 0;

            const y = timeSplitted[2];
            year = y ? parseInt(y) : 0;

            const h = timeSplitted[3]
            hours = h ? parseInt(h) : 0;

            const min = timeSplitted[4];
            minutes = min ? parseInt(min) : 0;
        }

        endTime.setUTCSeconds(0, 0);
        startTime.setUTCSeconds(0, 0);

        let fileTime = new Date();
        fileTime.setFullYear(year);
        fileTime.setMonth(month - 1);
        fileTime.setDate(day);
        fileTime.setHours(hours);
        fileTime.setMinutes(minutes);
        fileTime.setSeconds(0, 0);

        if (startTime <= fileTime && fileTime <= endTime) {
            file = answerFile;
        }

        return file;
    }
}

export default VideoRecordingResultItem;